import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, IRequestWithHeaderCpf } from './types';

// ACTIONS
import { consultaCpfSuccess, consultaCpfFailure } from './actions';

function* consultaCpfRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestWithHeaderCpf } =
		request;

	const { headers } = { ...payload };

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_API,
		`cicp`,
		{ cpf: payload.body.cpf },
		undefined,
		undefined,
		undefined,
		headers,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaCpfSuccess(response.data));
	} else if (response.error) {
		yield put(consultaCpfFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTA_CONSULTA_CPF_REQUEST, consultaCpfRequest),
]);
